export default __webpack_public_path__ + "static/media/promotion-decoration-1.6624419c.svg";